module.exports = __webpack_public_path__ + "static/media/iride_driver_2.c7cff1d8.png";